import React from "react";
import useFormComponentState from "../../../../common/forms/useFormComponentState";
import useValidation from "../../validation/useValidation";
import { SearchCriterion } from "../common/SearchCriterion";
import { DateComponent, DateComponentPassedProps } from "./DateComponent";
import { requiredRolesType } from "../../../../common/types/search/search";
import { visibilitySelectorType } from "../../../../common/types/common";

export const DATE_CRITERION_INITIAL_STATE = "";

interface DateCriterionProps extends DateComponentPassedProps {
	criterionKey: string;
	label: string;
	prefix?: string;
	quickSearch?: boolean;
	requiredRoles?: requiredRolesType;
	visibilitySelector?: visibilitySelectorType;
}

export const DateCriterion = ({
	criterionKey,
	label,
	prefix,
	quickSearch = false,
	requiredRoles,
	visibilitySelector,
	...props
}: DateCriterionProps) => {
	const { currentInput, onInputChange, onClearInput } = useFormComponentState(
		criterionKey,
		DATE_CRITERION_INITIAL_STATE,
	);
	const { valid } = useValidation(criterionKey);

	return (
		<SearchCriterion
			label={label}
			prefix={prefix}
			quickSearch={quickSearch}
			requiredRoles={requiredRoles}
			visibilitySelector={visibilitySelector}
		>
			<DateComponent
				criterionKey={criterionKey}
				currentInput={currentInput}
				label={label}
				onClearInput={onClearInput}
				onInputChange={onInputChange}
				prefix={prefix}
				quickSearch={quickSearch}
				valid={valid}
				{...props}
			/>
		</SearchCriterion>
	);
};
